import {
  ClassNameOverrides,
  IRichTextInformation,
} from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "../elements/RTF";
import { Separator } from "../elements/Separator";
import { lookupColourString } from "../lookups";

const DefaultColOffset =
  "col-span-4 col-start-2 md:col-span-5 md:col-start-4 lg:col-span-7 lg:col-start-8";

const BodyTextAsideOverrides: ClassNameOverrides = {
  h6: classNames("h6", DefaultColOffset),
  h5: classNames("h5", DefaultColOffset),
  h4: classNames("h4", DefaultColOffset),
  h3: classNames("h3", DefaultColOffset),
  h2: classNames("h2", DefaultColOffset),
  h1: classNames("h1", DefaultColOffset),
  p: classNames("p3", DefaultColOffset),
  div: classNames("p3", DefaultColOffset),
  ul: DefaultColOffset,
  ol: DefaultColOffset,
  table: DefaultColOffset,
  img: "col-span-full md:col-start-3 md:col-span-6 lg:col-start-2 lg:col-span-12 w-full",
  video:
    "col-span-full md:col-start-3 md:col-span-6 lg:col-start-2 lg:col-span-12 w-full",
  a: "col-span-4 col-start-2 md:col-start-4 md:col-span-5 lg:col-start-8 lg:col-span-7 w-full",
};

const AsideOverrides: ClassNameOverrides = {
  b: "p3",
  p: "p3",
  div: "p3",
  h1: "p3",
  h2: "p3",
  h3: "p3",
  h4: "p3",
  h5: "p3",
  h6: "p3",
};

export const BodyTextAside: React.FC<{
  heading?: string | null;
  body?: IRichTextInformation | null;
  sideText?: IRichTextInformation | null;
  date?: string | null;
  backgroundColour?: Queries.GraphCMS_Colour | null;
}> = ({ heading, body, sideText, date, backgroundColour }) => {
  return (
    <section
      data-component="Body Text With Aside"
      className={classNames(
        lookupColourString(backgroundColour, "bg"),
        lookupColourString(backgroundColour, "textForBg"),
        "relative w-full py-50px lg:pb-100px lg:pt-150px",
      )}
    >
      <div className="page-grid max-width gap-y-20px">
        {(heading ?? sideText ?? date) && (
          <div className="col-span-4 col-start-2 row-start-2 flex flex-col gap-y-20px md:col-span-2 md:col-start-2 md:row-start-1 lg:col-span-4 lg:col-start-3">
            {heading && (
              <>
                <h3 className="h6">{heading}</h3>
                <Separator spaceClass="" />
              </>
            )}
            {sideText && (
              <RTF content={sideText} classNameOverrides={AsideOverrides} />
            )}
            {date && <p className="p4">{date}</p>}
          </div>
        )}
        {body && (
          <RTF
            content={body}
            classNameOverrides={BodyTextAsideOverrides}
            className="col-span-4 col-start-2 row-start-1 content-start space-y-20px md:col-span-5 md:col-start-5 lg:col-span-7 lg:col-start-9"
          />
        )}
      </div>
    </section>
  );
};
